import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  sidebarCollapsed: boolean;
  sidebarOpen: boolean;
  activeWorklist: string | null;
  worklistFilters: Record<string, unknown>;
  printMode: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setActiveWorklist: (worklist: string | null) => void;
  setWorklistFilters: (filters: Record<string, unknown>) => void;
  setPrintMode: (enabled: boolean) => void;
}

export const useUIStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      sidebarOpen: true,
      activeWorklist: null,
      worklistFilters: {},
      printMode: false,
      toggleSidebar: () => set(state => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      setActiveWorklist: (worklist) => set({ activeWorklist: worklist }),
      setWorklistFilters: (filters) => set({ worklistFilters: filters }),
      setPrintMode: (enabled) => set({ printMode: enabled }),
    }),
    { name: 'vynahealth-ui', partialize: (state) => ({ sidebarCollapsed: state.sidebarCollapsed }) }
  )
);
